export default __webpack_public_path__ + "static/media/green_call_apdp.c170fc42.jpeg";